import React, { useEffect, useState } from "react";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import "../vehicle/vehicle.css"
import NoVehicleFound from "./NoVehicleFound";
import { handlePostRequest } from "../../../services/PostTemplate";
import { Checkbox } from "primereact/checkbox";
import LoadingSpinner from "../../components/Loading";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { handlePutRequest } from "../../../services/PutTemplate";
const VehicleDetails = () => {

    
    const [checked, setChecked] = useState(false);

    const [userVehicleList, setuserVehicleList] = useState([]);
    const [selectedVehicleId, setSelectedVehicleId] = useState(null);
    const [deleteVehicleId, setDeleteVehicleId] = useState(null);
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 540);
    const userId = useSelector((state) => state.authenticationSlice?.userId)
    const history = useHistory();
    const dispatch = useDispatch();



    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 540);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    useEffect(() => {
        const storedVehicleId = localStorage.getItem('selectedVehicleId');
        if (storedVehicleId) {
            setSelectedVehicleId(storedVehicleId);
            setChecked(true);
        }
    }, []);

    const validationSchema = Yup.object().shape({
        vehicleType: Yup.mixed().required("This field is required."),
        maker: Yup.mixed().required("This field is required."),
        model: Yup.mixed().required("This field is required."),
        year: Yup.mixed().required("This field is required."),
        vehicleRegistrationNo: Yup.mixed().required("This field is required."),
        avgMileage: Yup.mixed().required("This field is required."),
        color: Yup.mixed().required("This field is required."),
        sittingCapacity: Yup.mixed().required("This field is required."),
        province: Yup.mixed().required("This field is required."),
        city: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            vehicleType: "",
            maker: "",
            model: "",
            vehicleRegistrationNo: "",
            year: "",
            avgMileage: "",
            color: "",
            sittingCapacity: "",
            province: "",
            city: "",
        },

        onSubmit: async (data) => {
            let payload = {
                userId: userId,
                firstName: data?.firstName,
                lastName: data?.lastName,
                gender: data?.gender,
                dob: data?.dateOfBirth ? moment(data?.dateOfBirth).format("MM-DD-YYYY") : null,
            }
            setSaveBtnLoading(true);

            try {

            }
            catch (error) {
                // console.log(error)
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const handleUserVehicleList = async () => {
        setLoading(true);
        try {
            const response = await dispatch(handlePostRequest("api/user/getuservehiclelist", {
                userId: userId,
            }, loading, true));
            setuserVehicleList(response?.data);
            // console.log(response, "response success")
        } catch (error) {
            // console.error("Error fetching user vehicle list:", error);
        } finally {
            setLoading(false);
        }
    };
    const handleSelectedVehicle = async (vehicleId) => {
        try {
            const response = await dispatch(handlePostRequest("api/user/updateselectedvehicle", {
                userId: userId,
                vehicleId: vehicleId,
            }, true, true));
            localStorage.setItem('selectedVehicleId', vehicleId);
        } catch (error) {
            // console.error("Error updating selected vehicle:", error);
        }
    };


    useEffect(() => {
        handleUserVehicleList();
    }, []);


    const handleCheckboxChange = (vehicleId, isChecked) => {
        setChecked(isChecked);
        if (isChecked) {
            setSelectedVehicleId(vehicleId);
            handleSelectedVehicle(vehicleId);
            handleUserVehicleList()

        } else {
            setSelectedVehicleId(null);
            setSelectedVehicleId(null);
            localStorage.removeItem('selectedVehicleId');
        }
    };

    // Function to handle the deletion of a vehicle
    const handleDeleteTemplate = async (vehicleId) => {
        const payload = {
            userId: userId,
            vehicleId: vehicleId,
        };

        try {
            const response = await dispatch(handlePutRequest("api/user/deletevehicle", payload, true, true));
            // if (response?.success) {
            toast.success("Vehicle deleted successfully");
            handleUserVehicleList();
            // console.log(response.success, "response success")
            // setuserVehicleList(prevList => prevList.filter(vehicle => vehicle._id !== vehicleId));
            // }
        } catch (error) {
            toast.error("Error deleting vehicle");
        }
    };

    // Function to show the confirmation dialog
    const confirmDelete = (vehicleId) => {
        confirmDialog({
            message: 'Do you want to delete this vehicle?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            rejectClassName: 'p-button-white',
            accept: () => handleDeleteTemplate(vehicleId),
            reject: () => toast.error("Deletion cancelled"),
        });
    };

    return (
        <>

            <ConfirmDialog />


            <div className="">
                
                {loading ?

                    <LoadingSpinner />

                    :
                    (
                        userVehicleList?.length === 0 ? (
                            <NoVehicleFound />
                        ) : (
                            <div className="flex justify-content-center">
                                <div style={{ width: "80vw" }}>
                                    <div className="flex justify-content-end">
                                        {isMobile ? (
                                            <Button
                                                onClick={() => history.push("/add-vehicle")}
                                                icon="pi pi-plus"
                                                outlined
                                                rounded
                                                severity="info"
                                                aria-label="Add Vehicle"
                                            />
                                        ) : (
                                            <Button
                                                onClick={() => history.push("/add-vehicle")}
                                                className="font-medium mt-2 mb-2 text-lg w-9rem"
                                            >
                                                Add Vehicle
                                            </Button>
                                        )}
                                    </div>

                                    <div className="custom-grid">
                                        {userVehicleList?.data?.userVehicle?.map((vehicle, index) => (
                                            <div key={index} className="surface-card p-4">
                                                <div className="grid">
                                                    <div className="col-12 xl:col-12 lg:col-12 mb-1 h-full">
                                                        <div className="flex justify-content-between items-center">
                                                            <div style={{ width: "3rem", height: "3rem" }}>
                                                                <i className="pi pi-car text-white" style={{ fontSize: "2rem" }}></i>
                                                            </div>
                                                            <Button
                                                                type="button"
                                                                className="p-button p-button-danger"
                                                                onClick={() => {
                                                                    // handleDeleteTemplate(vehicle._id)
                                                                    confirmDelete(vehicle._id)
                                                                    setDeleteVehicleId(vehicle._id)
                                                                }}
                                                            >
                                                                <i className="pi pi-trash"></i>
                                                            </Button>
                                                        </div>

                                                        <div className="flex justify-content-between mt-2">
                                                            <h5 className="text-lg text-white">
                                                                Registration Number: {vehicle?.registrationNumber}
                                                            </h5>
                                                        </div>
                                                        <div className="flex justify-content-between mt-2">
                                                            <h5 className="text-lg text-white">{vehicle?.model?.make?.make}</h5>
                                                        </div>
                                                        <div className="flex justify-content-between mt-2">
                                                            <p className="text-md text-white">
                                                                Model: {vehicle?.model?.model} / Year: {vehicle?.year}
                                                            </p>
                                                        </div>
                                                        <div className="flex justify-content-between mt-4">
                                                            {vehicle?.status === "verified" ?
                                                                (
                                                                    <div className=" p-button p-button-success  p-button-rounded flex justify-content-center">
                                                                        <Checkbox
                                                                            className="custom-checkbox"
                                                                            style={{
                                                                                borderColor: "#16A34A!important",
                                                                                background: "#16A34A!important"
                                                                            }}
                                                                            onChange={(e) => handleCheckboxChange(vehicle._id, e.checked)}
                                                                            checked={checked && selectedVehicleId === vehicle._id}
                                                                        ></Checkbox>
                                                                        <label htmlFor="" className="ml-2">Verified</label>
                                                                    </div>
                                                                ) :
                                                                (
                                                                    <Button
                                                                        type="button"
                                                                        className={`p-button p-button-warning p-button-rounded`}
                                                                    >

                                                                        <i className="pi pi-exclamation-circle"></i>

                                                                        <span className="ml-2">Pending</span>
                                                                    </Button>
                                                                )}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))

                }
                {/* { : } */}
            </div>

        </>
    )
}

export default VehicleDetails